import { Link } from "react-router-dom";

const PackageEnrollmentSection = ({
  title,
  className = "tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative",
  packageEnrollment,
}) => {
  return (
    <section className={className}>
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>
      <div
        className={`tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-12 tw-text-gray-700 tw-py-4 tw-text-center`}
      >
        <Link
          to={"partners-list-in-package"}
          className="tw-border tw-underline tw-text-primary tw-border-secondary tw-rounded-lg tw-flex tw-flex-col tw-justify-center tw-items-center tw-p-2"
        >
          <p>{packageEnrollment?.numberOfPartners}</p>
          <p>Partners</p>
        </Link>
        <div className="tw-bg-primary tw-text-white tw-rounded-lg tw-flex tw-flex-col tw-justify-center tw-items-center tw-p-2">
          <p>First Added At</p>
          <p>{packageEnrollment?.firstAddedAt}</p>
        </div>
        <div className="tw-bg-primary tw-text-white  tw-rounded-lg tw-flex tw-flex-col tw-justify-center tw-items-center tw-p-2">
          <p>Last Added At</p>
          <p>{packageEnrollment?.lastAddedAt}</p>
        </div>
      </div>
    </section>
  );
};

export default PackageEnrollmentSection;
